import React from 'react';
import { Grid, Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { AutocompleteField } from '@inovando/react-components';
import { Form, Field } from 'react-final-form';
import createDecorator from 'final-form-focus';
import { TextField } from 'final-form-material-ui';

import { validate } from 'utils/validate';

import { schema } from './schema';
const focusOnErrors = createDecorator();

function SearchLogs({ onSubmit }) {
  return (
    <Box m={1}>
      <Form
        onSubmit={onSubmit}
        decorators={[focusOnErrors]}
        subscription={{ submitting: true }}
        validate={validate(schema)}
        render={({ handleSubmit, form, submitting }) => (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <Field
                  name="field"
                  component={AutocompleteField}
                  options={[
                    {
                      label: 'CPF',
                      value: 'cpf',
                    },
                    {
                      label: 'Nome',
                      value: 'name',
                    },
                    {
                      label: 'Email',
                      value: 'email',
                    },
                  ]}
                  label="Campo"
                  fullWidth
                  placeholder="Selecione"
                  variant="outlined"
                  labelAttr="label"
                  valueAttr="value"
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <Field
                  name="value"
                  component={TextField}
                  type="text"
                  label="Valor"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  name="filterByColumn"
                  component={AutocompleteField}
                  options={[
                    {
                      label: 'Antes da alteração',
                      value: 'before',
                    },
                    {
                      label: 'Depois da alteração',
                      value: 'after',
                    },
                  ]}
                  label="Filtrar por dados"
                  fullWidth
                  placeholder="Selecione"
                  variant="outlined"
                  labelAttr="label"
                  valueAttr="value"
                />
              </Grid>
            </Grid>
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Button
                disabled={submitting}
                variant="outlined"
                color="secondary"
                onClick={() => {
                  form.reset();
                  form.resetFieldState('field');
                  form.resetFieldState('value');
                  form.resetFieldState('filterByColumn');
                  onSubmit({});
                }}
              >
                Limpar
              </Button>

              <Box ml={1}>
                <Button
                  disabled={submitting}
                  variant="contained"
                  color="primary"
                  type="submit"
                >
                  Pesquisar
                </Button>
              </Box>
            </Box>
          </form>
        )}
      />
    </Box>
  );
}

export default SearchLogs;
